import { lazy } from 'react';
/**
 * The customer-portal task pane's code-split entry, plus a way to start the
 * download BEFORE it is rendered.
 *
 * Without the preload, the chunk request is serial with everything else in the
 * open: React renders the modal, hits the `lazy` boundary, and only then asks
 * for the chunk — behind a Suspense fallback, with the detail fetch running
 * alongside. Nothing can paint until it lands.
 *
 * `preloadCpTaskDrawerShell` is the same dynamic import, so calling it early is
 * free: the module registry dedupes, and `lazy` resolves instantly if the chunk
 * has already arrived. Call it on intent (the click that changes the hash) and
 * on idle from whatever surface can open a task.
 *
 * Lives in its own module so `use-query-params` can reach the preload without
 * importing the wrapper component that imports `use-query-params`.
 */ const importShell = ()=>import('./task-drawer/cp-task-drawer-shell');
export const preloadCpTaskDrawerShell = ()=>{
    // Fire-and-forget. A failed preload must not surface here — the `lazy`
    // boundary will retry the same import and report through its error boundary.
    void importShell().catch(()=>{});
};
export const CustomerPortalTaskDrawerShell = lazy(()=>importShell().then((m)=>({
            default: m.CustomerPortalTaskDrawerShell
        })));
